import { Link } from "react-router-dom";
import { SearchX } from "lucide-react";

import { CenteredMessage } from "@/components/centered-message";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  return (
    <CenteredMessage
      tone="neutral"
      icon={<SearchX className="h-7 w-7" />}
      title="Sayfa bulunamadı"
      description="Aradığın adres yok ya da taşınmış olabilir."
    >
      <Button asChild>
        <Link to="/">Genel bakışa dön</Link>
      </Button>
    </CenteredMessage>
  );
}
